import React, { Component } from 'react';
import * as RentMoneyBulkInsert from './Saga/RentMoneyBulkInsert';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
// import * as Monies from '../../Store/Monies';
import DateFnsUtils from '@date-io/date-fns';

import ja from "date-fns/locale/ja";

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import { Field} from 'redux-form';
import './Css/Kyousai.css';
import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
const moment = require('moment')
const styles = (theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});
// import DatePicker from "react-datepicker";
let timer: any
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  rent_money_bulk_insert_list: any,
  users_select: any,

  rent_money_bulk_insert_search: any,
  change_rent_money_bulk_insert_search: any,
  user_details: any,

}


interface State {
  refresh: boolean

}


class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      refresh: false
    }

    let rent_money_bulk_insert_search = this.props.rent_money_bulk_insert_search
    rent_money_bulk_insert_search.user_id = this.props.user_details.id
    this.props.change_rent_money_bulk_insert_search(rent_money_bulk_insert_search)

    this.onChange = this.onChange.bind(this);


    this.change_shoyuusha_tantou_no = this.change_shoyuusha_tantou_no.bind(this);
    // this.change_list = this.change_list.bind(this);

  }



  componentWillMount() {



  }




  change_shoyuusha_tantou_no(e: any, newValue: any) {
    let rent_money_bulk_insert_search = this.props.rent_money_bulk_insert_search
    rent_money_bulk_insert_search.shoyuusha_tantou_no = newValue ? newValue.value : 0
    // this.props.change_owner_mail_search(owner_mail_search)
    // this.props.set_owner_mail_search_list()
  }






  onChange(e: any) {
    // alert(e.target.name)

    // if (e.target.name === "tatemono_name") {
    //   clearTimeout(timer);

    //   let owner_mail_search = this.props.owner_mail_search
    //   owner_mail_search.tatemono_name = e.target.value
    //   this.props.change_owner_mail_search(owner_mail_search)
    //   timer = setTimeout(() => {

    //   }, 400);



  }
  render() {



    return (
      <div>

        <table style={{ border: "0px" }}>

          <tbody>

            <tr style={{ border: "0px" }}>

              {/* <td style={{ border: "0px" }}>
                <TextField
                  name="name"
                  onChange={this.onChange}
                  //   component="input"
                  type="text"
                  //placeholder=""
                  className="form-control"
                  label="お客様名"
                />

              </td> */}
              {/* <td style={{ border: "0px" }}>
                <TextField
                  name="tatemono_name"
                  onChange={this.onChange}

                  type="text"
                  label="物件名"
                  className="form-control"
                />
              </td> */}
              {/* <td style={{ border: "0px" }}>

                <Autocomplete
                  id="combo-box-demo"
                  options={this.props.users_select}
                  getOptionLabel={(option: any) => option.label}
                  style={{ width: 150 }}
                  defaultValue={this.props.users_select.filter((a: any) => a.value === this.props.rent_money_bulk_insert_list.user_id)[0]}
                  onChange={this.change_shoyuusha_tantou_no}
                  renderInput={(params) => <TextField  {...params} label="担当選択" />}
                />
                <Chip label={this.props.rent_money_bulk_insert_list.length + "件"} style={{ margin: 5, float: "right" }}
                  clickable color="primary" />
              </td> */}


            </tr >


          </tbody >
        </table >




      </div >
    );
  }
}




const mapStateToProps = (state: any) => {
  return {
    users_select: state.masterReducer.users_select,

    user_details: state.masterReducer.user_details,


    rent_money_bulk_insert_list: state.RentMoneyBulkInsert.rent_money_bulk_insert_list,
    rent_money_bulk_insert_search: state.RentMoneyBulkInsert.rent_money_bulk_insert_search,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    change_rent_money_bulk_insert_search(state: any) {
      dispatch(RentMoneyBulkInsert.change_rent_money_bulk_insert_search(state))
    },


  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Search));

